import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PeriodicSummarySettingsList from './PeriodicSummarySettingsList';
import { getModelPeriodicSummarySettings, getUserProfileWidget } from '../../selectors/index';
import {
  getPeriodicSummarySettingsThunk,
  describePeriodicSummarySettingThunk,
  postPeriodicSummarySettingThunk,
  setPeriodicSummarySettingChangeThunk,
  setPeriodicSummarySettingShowScreenStatusThunk,
  setCurrentPage,
  setPageFilter,
  setModelPeriodicSummaryFilteredDataThunk,
  uploadPeriodicSettingToS3AndUpdateShadowThunk
} from '../../actions/periodicSummarySetting';


import { getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';

const mapStateToProps = state => {
  return {
    periodicSummarySetting: getModelPeriodicSummarySettings(state),
    currentTimezone: getCurrentTimezone(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getPeriodicSummarySettings: (offset, limit, filter, modelCategoryId, modelId) => getPeriodicSummarySettingsThunk(offset, limit, filter, modelCategoryId, modelId, 'PERIODICSUMMARYSETTINGS'),
      savePeriodicSummarySetting: (periodicSummarySetting, widgetCode) => postPeriodicSummarySettingThunk(periodicSummarySetting, widgetCode),
      uploadPeriodicSummarySettings : (modelCategoryId, modelId) => uploadPeriodicSettingToS3AndUpdateShadowThunk(modelCategoryId, modelId, 'PERIODIC_SUMMARY_SETTING_UPLOAD_FILE'),
      describePeriodicSummarySetting: (modelCategoryId, modelId, periodicSummarySettingId) => describePeriodicSummarySettingThunk(modelCategoryId, modelId, periodicSummarySettingId, 'PERIODICSUMMARYSETTINGSEDIT'),
      changePeriodicSummarySetting: selectedPeriodicSummarySettings => setPeriodicSummarySettingChangeThunk(selectedPeriodicSummarySettings),
      setPeriodicSummarySettingShowScreenStatus: status => setPeriodicSummarySettingShowScreenStatusThunk(status),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setModelPeriodicSummaryFilteredDataThunk(filteredData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PeriodicSummarySettingsList);
